import { storage } from './storage.js';
import { uid } from './utils.js';

/* Perfiles: cada uno es una cuenta Xtream Codes o una lista M3U.
   Se guardan en localStorage del dispositivo; nunca se envían a terceros. */

/** SMB, carpetas del aparato y nubes: su «host» no es una dirección web (smb://…, local://…, dropbox:///…). */
export const isBridgeType = (type) => type === 'smb' || type === 'local' || type === 'dropbox' || type === 'onedrive';

export function normalizeHost(host) {
    let h = String(host || '').trim();
    if (!h) return '';
    if (!/^https?:\/\//i.test(h)) h = 'http://' + h;
    h = h.replace(/\/+$/, '');
    // Si el usuario pega la URL completa del player_api/get.php, nos quedamos con la base (origen + ruta del panel).
    try {
        const u = new URL(h);
        const base = u.pathname.replace(/\/(player_api|get|xmltv|panel_api)\.php$/i, '').replace(/\/+$/, '');
        return u.origin + base;
    } catch (e) {
        return h;
    }
}

export const profiles = {
    /** Cuenta remota (account.js) que replica altas, cambios y bajas en el servidor. */
    remote: null,

    list() {
        return storage.get('profiles', []) || [];
    },

    save(list) {
        storage.set('profiles', list);
    },

    get(id) {
        return this.list().find((p) => p.id === id) || null;
    },

    current() {
        const id = storage.get('currentProfile');
        const list = this.list();
        return list.find((p) => p.id === id) || list[0] || null;
    },

    setCurrent(id) {
        storage.set('currentProfile', id);
    },

    async add(data) {
        const list = this.list();
        let profile = Object.assign({
            id: uid(),
            name: '',
            type: 'xtream',
            host: '',
            username: '',
            password: '',
            m3uUrl: '',
            epgUrl: '',
            createdAt: Date.now()
        }, data);
        if (profile.type !== 'm3u' && !isBridgeType(profile.type)) profile.host = normalizeHost(profile.host);
        if (!profile.name) profile.name = profile.type === 'xtream' ? profile.username || 'Xtream' : profile.type === 'm3u' ? 'M3U' : profile.type === 'files' ? 'Archivos' : profile.type === 'smb' ? 'SMB' : profile.type === 'local' ? 'Local' : profile.type === 'dropbox' ? 'Dropbox' : profile.type === 'onedrive' ? 'OneDrive' : profile.type.charAt(0).toUpperCase() + profile.type.slice(1);
        if (this.remote) profile = Object.assign(profile, await this.remote.upsertProfile(profile));
        list.push(profile);
        this.save(list);
        return profile;
    },

    async update(id, data) {
        const list = this.list();
        const idx = list.findIndex((p) => p.id === id);
        if (idx === -1 || list[idx].shared) return null; // los compartidos son de solo lectura
        list[idx] = Object.assign({}, list[idx], data);
        if (list[idx].type !== 'm3u' && !isBridgeType(list[idx].type)) list[idx].host = normalizeHost(list[idx].host);
        if (this.remote) list[idx] = Object.assign(list[idx], await this.remote.upsertProfile(list[idx]));
        this.save(list);
        return list[idx];
    },

    /**
     * Una fuente recién añadida se SUMA al catálogo (sin quitar de en medio a las que ya había). Si no había ninguna principal, pasa a serlo.
     * Devuelve true si se ha sumado a una principal existente (y hay que recargar los añadidos), false si ha pasado a ser la principal.
     */
    joinCatalog(id) {
        const cur = this.current();
        if (!cur || cur.id === id) { this.setCurrent(id); return false; }
        const ids = storage.get('includedProfiles', []) || [];
        if (ids.indexOf(id) === -1) storage.set('includedProfiles', ids.concat([id]));
        return true;
    },

    async remove(id) {
        const own = this.get(id);
        // Un proveedor compartido por otra persona no se borra: solo se deja de verlo (los de código de invitación sí se quitan de la cuenta).
        if (own && own.shared && !own.viaCode) { if (this.remote && this.remote.user) await this.remote.unshareProfile(id, this.remote.user.email); }
        else if (this.remote) await this.remote.removeProfile(id);
        const list = this.list().filter((p) => p.id !== id);
        this.save(list);
        if (storage.get('currentProfile') === id) {
            storage.remove('currentProfile');
            if (list[0]) this.setCurrent(list[0].id);
        }
    },

    /** Parsea una URL M3U de Xtream (get.php?username=..&password=..) en credenciales. */
    fromM3uUrl(url) {
        try {
            const u = new URL(url);
            const user = u.searchParams.get('username');
            const pass = u.searchParams.get('password');
            if (user && pass && /get\.php|player_api\.php/.test(u.pathname)) {
                return { type: 'xtream', host: u.origin, username: user, password: pass };
            }
        } catch (e) { /* ignore */ }
        return null;
    }
};
